// src/firebase/orderService.js
import { 
  collection, 
  addDoc, 
  getDocs, 
  getDoc, 
  doc, 
  query, 
  where, 
  Timestamp, 
  updateDoc 
} from "https://www.gstatic.com/firebasejs/11.3.1/firebase-firestore.js";
import { db } from "./config";
  
  // Save a new order to Firestore
  export const saveOrder = async (orderData) => {
    try {
      const docRef = await addDoc(collection(db, "orders"), {
        ...orderData,
        created: Timestamp.now(),
        updated: Timestamp.now(),
        status: orderData.status || "pending"
      });
      console.log("Order saved with ID: ", docRef.id);
      return { id: docRef.id, ...orderData };
    } catch (error) {
      console.error("Error saving order: ", error);
      throw error;
    }
  };
  
  // Get a single order by ID
  export const getOrderById = async (orderId) => {
    try {
      const docRef = doc(db, "orders", orderId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        return { id: docSnap.id, ...docSnap.data() };
      } else {
        console.log("No such order!");
        return null;
      }
    } catch (error) {
      console.error("Error getting order: ", error);
      throw error;
    }
  };
  
  // Get orders by customer email
  export const getOrdersByEmail = async (email) => {
    try {
      const q = query(collection(db, "orders"), where("customer.email", "==", email));
      const querySnapshot = await getDocs(q);
      
      const orders = [];
      querySnapshot.forEach((doc) => {
        orders.push({ id: doc.id, ...doc.data() });
      });
      
      return orders;
    } catch (error) {
      console.error("Error getting orders by email: ", error);
      throw error;
    }
  };
  
  // Update order status
  export const updateOrderStatus = async (orderId, status) => {
    try {
      const orderRef = doc(db, "orders", orderId);
      await updateDoc(orderRef, {
        status: status,
        updated: Timestamp.now()
      });
      return true;
    } catch (error) {
      console.error("Error updating order status: ", error);
      throw error;
    }
  };
  
  // Save coupon to Firestore
  export const saveCoupon = async (couponData) => {
    try {
      const docRef = await addDoc(collection(db, "coupons"), {
        ...couponData,
        created: Timestamp.now(),
        isActive: couponData.isActive || true
      });
      return { id: docRef.id, ...couponData };
    } catch (error) {
      console.error("Error saving coupon: ", error);
      throw error;
    }
  };
  
  // Validate coupon code
  export const validateCoupon = async (code) => {
    try {
      const q = query(
        collection(db, "coupons"), 
        where("code", "==", code),
        where("isActive", "==", true)
      );
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        return null;
      }
      
      const couponDoc = querySnapshot.docs[0];
      const coupon = { id: couponDoc.id, ...couponDoc.data() };
      
      // Check if coupon has expired
      if (coupon.expiryDate && coupon.expiryDate.toDate() < new Date()) {
        return null;
      }
      
      return coupon;
    } catch (error) {
      console.error("Error validating coupon: ", error);
      throw error;
    }
  };